import { Component, DestroyRef, inject, signal } from '@angular/core';
import { TranslatePipe } from 'src/app/core/pipe/translate.pipe';
import { UpperCasePipe, CommonModule } from '@angular/common';
import { IubendaService } from 'src/app/services/gdpr/iubenda.service';
import { AppConfigService, Log } from '@core/services/config/app-config.service';
import { IubendaLinkComponent } from '../iubenda/iubenda-link.component';
// Aggiunti per il form
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SettingService } from 'src/app/services/setting.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-newsletter-form',
    standalone: true, // Assicurati che sia standalone se Angular 19
    imports: [
        CommonModule,
        TranslatePipe,
        UpperCasePipe,
        IubendaLinkComponent,
        ReactiveFormsModule // Fondamentale
    ],
    templateUrl: './newsletter-form.component.html',
    styleUrl: './newsletter-form.component.scss'
})
export class NewsletterFormComponent {
    private iubendaService = inject(IubendaService);
    private appConfig = inject(AppConfigService);
    private settingService = inject(SettingService);
    private destroyRef = inject(DestroyRef);

    public leggi_privacy: string = '';
    public isSubmitting = signal(false);
    public message = signal<{type: 'success' | 'error', text: string} | null>(null);

    // Definizione del Form
    public newsletterForm = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
        newsletter_privacy: new FormControl(false, Validators.requiredTrue),
        newsletter_ok: new FormControl(false, Validators.requiredTrue)
    });

    ngOnInit() {
        this.leggi_privacy = this.appConfig.translate('account.leggi_privacy');
    }

    onSubmit() {
        if (this.newsletterForm.invalid) {
            this.newsletterForm.markAllAsTouched();
            return;
        }

        this.isSubmitting.set(true);
        this.message.set(null);

        const payload = this.newsletterForm.value;

        this.iubendaService.iubendaSubmitData('newsletterForm');

        this.settingService.subscribeNewsletter(payload).pipe( takeUntilDestroyed( this.destroyRef ) ).subscribe( (res : any) => {
            this.isSubmitting.set(false);

            if(res.stato == 'OK'){
                this.message.set({type: 'success', text: this.appConfig.translate('footer.news_ok_confirm')});
                this.newsletterForm.reset();
            }

            if(res.stato == 'DUP'){
                this.message.set({type: 'error', text: this.appConfig.translate('footer.news_ko_confirm')});
            }
        });
        
    }

}